var map = {
	"./Autodesk_Icon.png": 8814,
	"./Autodesk_Icon_Dark.png": 4431,
	"./AvidXchange_Icon.png": 1220,
	"./Billy_Icon.png": 7858,
	"./BusinessCentral_Icon.png": 6321,
	"./CMiC_Icon.png": 1740,
	"./COINS_Icon.png": 8048,
	"./ChromeRiver_Icon.png": 318,
	"./Fusion_Icon.png": 6140,
	"./IFS_Icon.png": 8342,
	"./Intacct_Icon.png": 4644,
	"./JDE_Icon.png": 9203,
	"./JDE_Icon_Dark.png": 7508,
	"./Kahua_Icon.png": 9912,
	"./MBC_Icon.png": 2534,
	"./MRIX_Icon.png": 3518,
	"./NetSuite_Icon.png": 4297,
	"./NetSuite_Icon_Dark.png": 5410,
	"./Northspyre_Icon.png": 3358,
	"./Northspyre_Icon_Dark.png": 911,
	"./PmWeb_Icon.png": 3137,
	"./Procore_Icon.png": 1074,
	"./Procore_Icon_Dark.png": 4123,
	"./Psft_Icon.png": 7735,
	"./Ramp_Icon.png": 1844,
	"./SAP_Icon.png": 9350,
	"./Sage_Icon.png": 3716,
	"./Spectrum_Icon.png": 2591,
	"./VantagePoint_Icon.png": 8564,
	"./Vista_Icon.png": 8071,
	"./Xero_Icon.png": 7400,
	"Images/Icons/Autodesk_Icon.png": 8814,
	"Images/Icons/Autodesk_Icon_Dark.png": 4431,
	"Images/Icons/AvidXchange_Icon.png": 1220,
	"Images/Icons/Billy_Icon.png": 7858,
	"Images/Icons/BusinessCentral_Icon.png": 6321,
	"Images/Icons/CMiC_Icon.png": 1740,
	"Images/Icons/COINS_Icon.png": 8048,
	"Images/Icons/ChromeRiver_Icon.png": 318,
	"Images/Icons/Fusion_Icon.png": 6140,
	"Images/Icons/IFS_Icon.png": 8342,
	"Images/Icons/Intacct_Icon.png": 4644,
	"Images/Icons/JDE_Icon.png": 9203,
	"Images/Icons/JDE_Icon_Dark.png": 7508,
	"Images/Icons/Kahua_Icon.png": 9912,
	"Images/Icons/MBC_Icon.png": 2534,
	"Images/Icons/MRIX_Icon.png": 3518,
	"Images/Icons/NetSuite_Icon.png": 4297,
	"Images/Icons/NetSuite_Icon_Dark.png": 5410,
	"Images/Icons/Northspyre_Icon.png": 3358,
	"Images/Icons/Northspyre_Icon_Dark.png": 911,
	"Images/Icons/PmWeb_Icon.png": 3137,
	"Images/Icons/Procore_Icon.png": 1074,
	"Images/Icons/Procore_Icon_Dark.png": 4123,
	"Images/Icons/Psft_Icon.png": 7735,
	"Images/Icons/Ramp_Icon.png": 1844,
	"Images/Icons/SAP_Icon.png": 9350,
	"Images/Icons/Sage_Icon.png": 3716,
	"Images/Icons/Spectrum_Icon.png": 2591,
	"Images/Icons/VantagePoint_Icon.png": 8564,
	"Images/Icons/Vista_Icon.png": 8071,
	"Images/Icons/Xero_Icon.png": 7400
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4141;